import formInputFieldMixin from './formInputField.js';
import formSelectTownPropsMixin from './formSelectTownProps.js';

export default {
  mixins: [formInputFieldMixin, formSelectTownPropsMixin],
};
